import { flow } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as RONEA from 'fp-ts/ReadonlyNonEmptyArray';
import * as S from 'fp-ts/string';
import { filename } from './filename';
export var extension = flow(filename, S.split('.'), function (a) {
  return a.length < 2 ? O.none : O.some(RONEA.last(a));
});